export default "/img/connectlogo.c4fc09098068b0b7b3568db5448a23f8.png";